// Cermin `App\Support\MenuPrivilegeCatalog::PROFESI_DEFAULT` — ubah keduanya bersamaan.
export const PRIVILEGE_PROFESI_DEFAULT: Record<string, string[]> = {
  surveilans_hh: ["Perawat"],
  surveilans_apd: ["Perawat"],
  antimikroba_reserve: ["Farmasi"]
};

export const PRIVILEGE_PROFESI_ACTIONS = ["view", "create", "update"];

export function privilegeFromProfesi(
  domain: string,
  action: string,
  profesi: string | null | undefined
): boolean {
  if (!profesi) return false;
  if (PRIVILEGE_PROFESI_ACTIONS.indexOf(action) < 0) return false;
  const profesiList = PRIVILEGE_PROFESI_DEFAULT[domain];
  return !!profesiList && profesiList.indexOf(profesi) > -1;
}

export function privilegePrefixFromProfesi(
  prefix: string,
  action: string,
  profesi: string | null | undefined
): boolean {
  return Object.keys(PRIVILEGE_PROFESI_DEFAULT).some(
    domain =>
      domain.indexOf(prefix) === 0 &&
      privilegeFromProfesi(domain, action, profesi)
  );
}
